import React from "react";
import { Helmet } from "react-helmet";

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: "Welcome to BooksRUs",
  description: "Pick Your Favorite Books Today!",
  keywords: "books, fantastic books, excellent choices",
};

export default Meta;
